import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: "parchment" | "wood" | "default";
    padding?: "none" | "sm" | "md" | "lg";
    jagged?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(({
    className = "",
    variant = "default",
    padding = "md",
    jagged = true,
    children,
    ...props
}, ref) => {
    const variants = {
        default: "bg-white dark:bg-[#2c2a25] border-4 border-[#deb887] dark:border-[#4e342e]",
        parchment: "bg-[#fff8e1] dark:bg-[#3e2723] border-4 border-wood-dark dark:border-[#5d4037]",
        wood: "bg-[#d7ccc8] dark:bg-[#4e342e] border-4 border-[#5d4037]",
    };

    const paddings = {
        none: "",
        sm: "p-2",
        md: "p-4",
        lg: "p-6",
    };

    return (
        <div
            ref={ref}
            className={`
        ${variants[variant]}
        ${paddings[padding]}
        ${jagged ? 'jagged-corners' : 'rounded-xl'}
        shadow-pixel-sm
        ${className}
      `}
            {...props}
        >
            {children}
        </div>
    );
});

Card.displayName = "Card";
